import { ACTIONS } from '../actions/dashboard';
import moment from 'moment';

const leagueHeader = ['順位', 'チーム', '試合', '勝', '負', '分', '勝率', 'ゲーム差','残試合', '連勝連敗', '得点', '失点', '打率', '本塁打', '盗塁', '防御率'];
const listButton = [
	{ name: '前の週', event: 'back7days' },
	{ name: '前日', event: 'yesterday' },
	{ name: '今日', event: 'today' },
	{ name: '翌日', event: 'tomorrow' },
	{ name: '次の週', event: 'next7days' }
];
const titleTable1 = {
	dot: true,
	text: 'セ・リーグ',
	background: 'green-dot',
	pl: '',
};
const titleTable2 = {
	dot: true,
	text: 'パ・リーグ',
	background: 'blue-dot',
	pl: '',
};
const titleTable3 = {
	dot: true,
	text: 'セ・リーグ',
	background: 'green-dot',
	pl: 'pl-16 ',
};
const titleTable4 = {
	dot: true,
	text: 'パ・リーグ',
	background: 'blue-dot',
	pl: 'pl-16',
};
const titleTable5 = {
	dot: false,
	text: '交流戦',
	background: 'green-dot',
	pl: 'pl-16',
};

export default (state = {
	leagueHeader, listButton,
	titleTable1, titleTable2, titleTable3, titleTable4, titleTable5
}, action) => {
	switch (action.type) {
		case ACTIONS.GET_ITEM_DASHBOARDS_TEAM_SUCCESS:
			return {
				...state,
				status: action.type,
				response: action.data.data,
				year: moment(new Date(action.data.target[1])).format('YYYY'),
				headerDate: action.data.target.map(x => moment(new Date(x)).format('MM/DD')),
			};
		case ACTIONS.GET_ITEM_DASHBOARDS_SUCCESS:
			return {
				...state,
				statusDashboard: action.type,
				responseDashboard: action.data.data,
			};
		case ACTIONS.GET_DROPDOWN_DASHBOARD_SUCCESS:
			return {
				...state,
				statusDashboard : action.type,
				dataDropdown : action.data
			};
		case ACTIONS.GET_ITEM_DASHBOARDS_ERROR:
			return {
				...state,
				statusDashboard: action.type,
			};
		case ACTIONS.GET_ITEM_DASHBOARDS_TEAM_ERROR:
		case ACTIONS.GET_DROPDOWN_DASHBOARD_ERROR:
			return {
				...state,
				status: action.type,
			};

		default:
			return state;
	}
};
